import { CurrencyFormat } from '@lt/components';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 11px;
`;

export const Link = styled.a`
  text-decoration: none;
  display: flex;
  color: #007aff;

  & + & {
    margin-top: 6px;
  }
`;

export const Title = styled.h3`
  color: #17181a;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 4px;
`;

export const Price: typeof CurrencyFormat = styled(CurrencyFormat)`
  color: #4d4d4d;
  margin-left: auto;
`;
